interface TreeNode{
    id: number;
    parentId: number;
    children: TreeNode[];
}

class Utils{
    public toTree(nodes: Array<TreeNode>){
        const map = new Map();
        const roots: Array<TreeNode> = new Array<TreeNode>();
        for(const node of nodes){
            if(node.parentId === 0){
                roots.push(node);
            }

            map.set(node.id, node);
        }

        for(const node of nodes){
            if(node.parentId > 0){
                if(map.has(node.parentId)){
                    map.get(node.parentId).children.push(node);
                } else {
                    roots.push(node);
                }
            }
        }

        return roots;
    }
    public setCookie(name: string, value: string, expiredDays: number){
        const d = new Date();
        d.setTime(d.getTime()+(expiredDays*24*60*60*1000));
        const expires = "expires="+ d.toUTCString();
        document.cookie = name + "=" + encodeURIComponent(value) + "; " + expires + "; path=/";
    }

    public readCookie(name: string){
        const cname = name + "=";
        const ca = document.cookie.split(';');
        for(let i=0; i<ca.length; i++)
        {
            const c = ca[i].trim();
            if (c.indexOf(cname)==0) {
                const cv = c.substring(cname.length,c.length);
                return decodeURIComponent(cv);
            }
        }
        return "";
    }

    //保留1位小数
   public numToFixed(value: any) {
       if (value == undefined || isNaN(value) || value == -Infinity || value == Infinity) {
           return 0;
       }
       if (!isNaN(value) && value % 1 === 0) {
           return value;
       } else {
           return parseFloat(value.toFixed(2));
       }
    }

    //文件重命名
    public renameDownloadFile(url: string, rename: string, _suffix: string){
        return new Promise(resolve => {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = 'blob';
            xhr.onload = () => {
                if (xhr.status === 200) {
                    resolve(xhr.response);
                }
            };
            xhr.send();
        }).then(blob => {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = rename+_suffix;
            link.click();
        });
    }

    //通过年限获取日期
    public toYearDate(number: number){
        const date = new Date();
        date.setDate(date.getDate()-365.25*number);
        return new Date(date).getTime();

    }
    public base64ConvertFile(urlData: any, filename: string) { // 64转file
        const arr = urlData.split(',');
        const type = arr[0].match(/:(.*?);/)[1];
        const fileExt = type.split('/')[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename + "." + fileExt, {
            type: type
        });
    }
}
const utils = new Utils();
export default utils;
